import { editableArea, defaultEditableArea } from '../editableArea'

export function removeEditableArea() {
  editableArea.area = { ...defaultEditableArea }
}
